import { styled } from '@mui/material/styles';
import { useAtom, useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { PopupMenu } from '../../../../../components/PopupMenu/PopupMenu';
import {
  kpiConfigAtom,
  kpiConfigByKeyMapAtom,
  kpiGroupsByIdAtom,
} from '../../../../../services/state/KPIConfigState';
import { SelectItem } from '../../../../../types';
import {
  IKpiSelectItem,
  kpiEntitiesToSelectItem,
  kpiSelectItemsToPreference,
  selectedKpisByCompanyPrefAtom,
} from '../../../state/ProfileViewSettings';
import { selectedCompanyIdProfileAtom } from '../../../state/UIStateJ';
import { sortGroupableOptions } from '../../../utils/sortGroupableOptions';

const Wrapper2 = styled('div')`
  display: flex;
  position: relative;
  margin-left: auto;
`;

export const AddStatistic = () => {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const [preference, setPreference] = useAtom(selectedKpisByCompanyPrefAtom(companyId));
  const kpisByEntityField = useAtomValue(kpiConfigByKeyMapAtom);
  const selectedItems = useMemo(() => {
    return kpiEntitiesToSelectItem(preference.selectedFields, kpisByEntityField);
  }, [preference, kpisByEntityField]);
  const availableKpis = useKPIOptions();

  const handleChange = (selected: SelectItem[]) => {
    setPreference(kpiSelectItemsToPreference(selected as IKpiSelectItem[]));
  };

  return (
    <Wrapper2>
      <PopupMenu
        items={availableKpis}
        onChange={handleChange}
        selectedItems={selectedItems}
        label={'Select KPIs'}
        groupable
        searchable
        searchPlaceholder='Search for KPI name'
      />
    </Wrapper2>
  );
};

export function useKPIOptions() {
  const config = useAtomValue(kpiConfigAtom);
  const kpiGroupsById = useAtomValue(kpiGroupsByIdAtom);

  return sortGroupableOptions(
    config.map((field) => {
      return {
        value: field.displayName,
        id: field.id,
        entityField: field.entityField,
        group: kpiGroupsById.get(field?.kpiGroupId ?? -1)?.name ?? field.gridMeta?.group,
      } satisfies IKpiSelectItem;
    })
  );
}
